import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
import ChoiceStaffPlanning from '../../../components.js/serveur/planning/ChoiceStaffPlanning'
import ModalAddBooking from '../../../components.js/serveur/planning/ModalAddBooking'
import ModalPlanning from '../../../components.js/serveur/planning/ModalPlanning'
import PlanningServeur from '../../../components.js/serveur/planning/PlanningServeur'
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
import useForm from './../../../hooks/useForm'
import useFirebase from './../../../firebase/useFirebase'
// IMAGES
import imageCalendar from '../../../images/calendargif.gif'
import usePlanning from '../../../hooks/usePlanning'
import ModalListDays from './../../../components.js/serveur/planning/ModalListDays'
// FORMAT
import format from 'date-fns/format'
import ModalConfirm from '../../../components.js/modal/ModalConfirm'

const INITIAL_STATE = {
    idStaff:'',
    surnameStaff:'',
    nameStaff:'',
    name:'',
    surname:'',
    service:'',
}

const Planning = () => {
    const { user } = useContext(AppContext)
    const [dataBooking, setDataBooking] = useState([]) 
    const [montage, setMontage] = useState(true)
    const { 
        _displayHours, 
        _display60Days, 
        _converteTimeToHours, 
        _converteTimeToSingleHour,
        _converteTimeMinutes,
        _convertHoursToTime,   
        _choiceStaff, 
        _deleteState,  
        _compareDay,  
        _compareHours, 
        _compareCurrentDayHours, 
        _compareBooking, 
        valuesPlanning  
    } = usePlanning(INITIAL_STATE) 
    const { values, setValues, handleChange, refresh } = useForm(INITIAL_STATE) 
    const { writeData, readData, deleteData, updateData,booking, staff, datesOff, services } = useFirebase() 
    let navigate = useNavigate()
    const [choiceService, setChoiceService] = useState([])
    const [choiceDay, setChoiceDay] = useState()

    useEffect(() => {
        readData(user.uid)
        const date = format(new Date(), 'MM/dd/yyyy')
        setChoiceDay(date)
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    if (montage) return <Spinner />

    const _handleAddBooking = (date,dateInt,dateShow,hours,nameClient,idStaff,surnameStaff,nameStaff) => {
        const duration = parseInt(choiceService.durationService)
        const dur = duration / 15
        for (let i = 0; i < dur ; i++) {
            const data = { 
                date:date, 
                dateShow:dateShow, 
                hours:hours, 
                nameClient:nameClient, 
                surnameClient:'',
                idStaff:idStaff,
                surnameStaff:surnameStaff,
                nameStaff:nameStaff,
                idService:choiceService.idService,
                nameService:choiceService.nameService,
                priceService:choiceService.priceService,
                durationService:choiceService.durationService,
                occurence:i,
                idStandard:dateInt+idStaff
            }
            const h = hours+i
            updateData('entreprises/'+user.uid+'/booking/'+dateInt+idStaff+h,data)
        }
        refresh()
        setChoiceService([])
    }
 
    // DELETE BOOKING 
    const _handleDeleteBooking = () => {
        // console.log('Planning _handleDeleteBooking ', dataBooking.idStandard, dataBooking.hours, dataBooking.duration) 
        const duration = parseInt(dataBooking.duration)
        const dur = duration / 15
        console.log('Planning _handleDeleteBooking ', dataBooking.idStandard+dur)
        for (let i = 0; i < dur; i++) {
            const h = dataBooking.hours+i
            deleteData('entreprises/'+user.uid+'/booking/'+dataBooking.idStandard+h)
        }
        // deleteData('entreprises/'+user.uid+'/booking/'+dataBooking.id)
        refresh()
        setDataBooking([])
        setChoiceService([])
    }

    // REFRESH MODAL
    const _refreshModal = () => {
        console.log('Planning _refreshModal ', values.name)
        refresh()
        setChoiceService([])
    }


    return (
        <div className='container-fluid'>    
 
            <HeaderReturn title='Planning' image={imageCalendar} link='/homeServeur' /> 
 
            {/* CHOISIR UN STAFF POUR LE PLANNING */} 
            <ChoiceStaffPlanning 
                valuesPlanning={valuesPlanning} 
                _deleteState={_deleteState}
                staff={staff}
                _choiceStaff={_choiceStaff}
            />  

            {/* SHOW PLANNING */} 
            <PlanningServeur  
                _displayHours={_displayHours}
                _converteTimeToHours={_converteTimeToHours}
                _converteTimeToSingleHour={_converteTimeToSingleHour}
                _converteTimeMinutes={_converteTimeMinutes}
                _convertHoursToTime={_convertHoursToTime}
                _display60Days={_display60Days}
                booking={booking}
                staff={staff}
                datesOff={datesOff}
                services={services}
                valuesPlanning={valuesPlanning}
                setDataBooking={setDataBooking}
                _compareDay={_compareDay}
                _compareHours={_compareHours}
                _compareCurrentDayHours={_compareCurrentDayHours}
                _compareBooking={_compareBooking}
                user={user}
                values={values}
                choiceService={choiceService}
                choiceDay={choiceDay}
            />
              
            {/* MODAL PLANNING */}  
            {/* <ModalPlanning
                staff={staff}
                _choiceStaff={_choiceStaff}
            />  */}

            {/* MODAL CHOICE DAYS */}
            <ModalListDays 
                setChoiceDay={setChoiceDay} 
                staff={staff}
                _display60Days={_display60Days}
            /> 

            {/* MODAL ADD BOOKING */} 
            <ModalAddBooking
                dataBooking={dataBooking}
                _converteTimeToHours={_converteTimeToHours}
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                _handleAddBooking={_handleAddBooking}
                services={services}
                choiceService={choiceService}
                setChoiceService={setChoiceService}
                _refreshModal={_refreshModal}
            /> 

            {/* MODAL CONFIRM DELETE */}
            <ModalConfirm 
                title='Êtes vous sûr de vouloir supprimer la réservation ?'
                _handleModal={_handleDeleteBooking}
            />
        </div>
    )
}

export default Planning

